import AdvivaCore from '../../../scripts/libs/advivapress';

var ApCore = new AdvivaCore();

export default {
    init() {

        let AdvivaPress = {

            header: '#site-masthead',
            all_wrapper: '.main-wrapper',
            main:'#main',
            nav:'#header-nav',
            main_menu:'.main_menu',
            mega_menu_item: '.ap_menu-item-megamenu',
            to_top: '#toTop',
            page_slider: '.ap-slider',
            footer: '#footer',
            mobile_menu_btn: '#menu_mobile_btn',

            xl_brk: 1400,
            lg_brk: 1200,
            md_brk: 1024,
            sm_brk: 767,
            xs_brk: 576,

            init() {
                this.header_nav = jQuery(this.nav);

                this.header = jQuery(this.header);

                this.footer = jQuery(this.footer);

                this.wrapper = jQuery(this.all_wrapper);

                this.body = jQuery('body');

                this.mobile_menu_btn = jQuery(this.mobile_menu_btn);

                this.main_menu = jQuery(this.main_menu);

                ApCore.init();

                ApCore.autoscrollOnHash();

                this.domManager();

                this.clickListenerManager();
            },

            /**
             *  DOM manager
             *
             */
            domManager(){
                // let parent = this;

                // SET ANIMATIONS
                window.AdvivaAnimations.init();

                this.body.on('advivapress.window.scroll', function () {
                    ApCore.setScrollDirection();
                    ApCore.setCurrentScrollTop();
                });

                // MENU
                this.megaMenuManager();
                this.hoverMegaMenu();

                // FORMS
                ApCore.GformManager();
                jQuery(document).bind('gform_post_render', ApCore.GformManager);

                // To TOP
                ApCore.scrollToTopManager(this.to_top, 200);

                // ON Scroll
                // this.body.on('advivapress.window.scroll', function () {

                //     if(window.currentScroll > parent.header.innerHeight()){
                //         parent.header.addClass('sticky-ready');
                //     }else{
                //         parent.header.removeClass('sticky-ready');
                //     }
                //     if(window.isScrollingUp && window.currentScroll > parent.header.innerHeight()){
                //         parent.header.addClass('sticky');
                //     }else{
                //         parent.header.removeClass('sticky');
                //     }

                //     if(!parent.header.hasClass('sticky-ready')){
                //         $(window).trigger('resize');
                //     }
                // });

                // Page Slider
                this.initPageSlider();

                // column sticky
                this.columnSticky();

                // LANG
                ApCore.toggleWpmlLangSel();

                ApCore.apTableManager();

                ApCore.replaceSVGS();


                // if(!(this.header.hasClass('sticky'))) {
                //     this.wrapper.css('padding-top', this.header.outerHeight() + 'px');
                // }

                // this.body.on('advivapress.window.finalize advivapress.window.resize advivapress.window.scroll', function() {
                //     if ($(window).width() <= parent.md_brk) {
                //         parent.main_menu.css({'top': parent.header.outerHeight() + 'px', 'height': 'calc( 100% - '+ parent.header.outerHeight() +'px)'});
                //     }else{
                //         parent.main_menu.css({'top': '', 'height': ''});
                //     }
                // });

                // ON Load
                // this.body.on('advivapress.window.finalize advivapress.window.resize', function(){
                //     if(!(parent.header.hasClass('sticky'))) {
                //         parent.wrapper.css('padding-top', parent.header.outerHeight() + 'px');
                //     }

                //     // image not boxed
                //     if($('.image_not_boxed').length > 0){
                //         var main_width = $('#content').width();
                //         $('.image_not_boxed').each(function(){
                //             var container_width = $(this).closest('.row').width();
                //             var image_width = $(this).width();
                //             var new_image_width = ((main_width - container_width) / 2) + image_width;
                //             $(this).parent('.col-inner').parent('div[class*="col-"]').addClass('ap-col-no-padding');
                //             $(this).children('.bg_not_boxed_image').css('min-width', new_image_width);
                //             if($(window).width() <= parent.md_brk && (new_image_width > container_width)){
                //                 $(this).children('.bg_not_boxed_image').css('min-width', 'auto');
                //             }
                //         });
                //     }

                //     // parent.check_position_simple_menu();
                //     parent.stickyButtonLp();

                //     //SLIDER
                //     ApCore.ApSlickManager();
                // });

                // section collapse lp
                ApCore.SectionCollapse();

                // FOOTER
                this.footerManager();
            },

            /**************/

            footerManager(){

                if($(window).width() <= this.xs_brk){
                    let footer_title = this.footer.find('.vca_footer-col').find('.ap_title');
                    footer_title.on('click', function(){
                        jQuery(this).toggleClass('active');
                        jQuery(this).parent().find('.vc_wp_custommenu').slideToggle();
                    });
                }
            },

            initPageSlider(){
                let slider = jQuery(this.page_slider);
                slider.css('opacity',0);

                slider.each(function(i,el){
                    let el_slider = jQuery(el);

                    // init
                    el_slider.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 1,
                        autoplay:true,
                        autoplaySpeed: 2000,
                        slidesToScroll:1,
                        variableWidth:false,
                        responsive: [
                            {
                                breakpoint:500,
                                settings: {
                                    slidesToShow:1,
                                    slidesToScroll:1,
                                },
                            },
                        ],
                    }).fadeTo(150,1);
                });

            },

            // CLICK
            clickListenerManager(){
                let parent = this;

                // TO TOP
                jQuery('#toTop').click(function(){
                    ApCore.scrollToTop();
                });

                // BOX CLICK
                jQuery('.box-click-js').click(function(evt){
                    evt.stopPropagation();
                    evt.preventDefault();
                    evt = jQuery(evt.currentTarget);
                    document.location = evt.find('a').attr('href');
                    return false;
                });

                // Scroll to element
                $('.btn-scroll-to-element').on('click', function (e) {
                    e.preventDefault();
                    ApCore.scrollToElement($(this).attr('data-scrolltoelement'));
                });

                // VIDEO BOX PLAYER
                $('.vca_video_box .vca_video-preview').on('click', function(){
                    $(this).fadeTo(300,0,function(){
                        $(this).hide();
                        $(this).parent('.vca_video_box').addClass('start-video')
                    });
                    var data_src = $(this).parent().find('iframe').data('src');
                    $(this).parent().find('iframe').attr('src', data_src);
                });

                // FAQ
                $('.ap_container-faq .ap_faq .ap_title-faq').click(function(){
                    $(this).toggleClass('active-faq');
                    $(this).siblings('.ap_text-faq').slideToggle();
                });

                // MOBILE MENU
                this.mobile_menu_btn.click(function(){
                    parent.body.toggleClass('noScroll');

                    if ($(window).width() <= parent.md_brk) {
                        parent.main_menu.css({'height': 'calc( 100%'});
                    }

                    $(this).toggleClass('open');
                    parent.main_menu.toggleClass('menu_open');
                    parent.main_menu.slideToggle();
                });

            },

            megaMenuManager(){
                let parent = this;
                jQuery('.menu-item').each(function(){
                    if(jQuery(this).children('.sub-menu').length > 0){
                        jQuery(this).addClass('ap_menu-item-megamenu simple_megamenu');
                    }
                });
                jQuery(parent.main_menu).find('.ap_menu-item-megamenu > a').after('<i class="icon-chevron-down ap_menu-arrow"></i>');
                $('.vca_item_link_wrap').each(function(){
                    if($(this).find('.ap-link').hasClass('active')){
                        $(this).parents('.ap_menu-item-megamenu').addClass('active');
                    }
                });
            },

            check_position_simple_menu(){
                $('.simple_megamenu').each(function(){
                    var width_simple_menu = $(this).find('.sub-menu').outerWidth();
                    var offset_body_main = ($(window).width() - $('.main-wrapper').outerWidth()) / 2;
                    var left_offset = $(this).offset().left - offset_body_main;
                    var right_offset = $('.main-wrapper').outerWidth() - (left_offset + width_simple_menu);
                    if(right_offset < 5){
                        $(this).find('.sub-menu').css({'left': 'auto', 'right': '0'});
                    } else {
                        $(this).find('.sub-menu').css({'left': '5px', 'right': 'auto'});
                    }

                });
            },

            hoverMegaMenu(){
                if($(window).width() > this.md_brk){
                    $(this.mega_menu_item).mouseover(function () {
                        $(this).addClass('open_megamenu');
                    });
                    $(this.mega_menu_item).mouseout(function () {
                        $(this).removeClass('open_megamenu');
                    });
                }else{
                    $(this.mega_menu_item).find('.ap_menu-arrow').on('click',function () {
                        if($(this).hasClass('icon-chevron-down')){
                            $(this).removeClass('icon-chevron-down').addClass('icon-chevron-top');
                        }else{
                            $(this).removeClass('icon-chevron-top').addClass('icon-chevron-down');
                        }
                        $(this).parent().toggleClass('open_megamenu');
                        $(this).parent().find('.sub-menu').slideToggle();
                    });

                    if($(this.main_menu).children('.wpml-ls-item').length > 0){
                        var language_mobile = '<li class="menu-item menu-languages wpml-ls-item wpml-ls-menu-item">';
                        $(this.main_menu).children('.wpml-ls-item').each(function(){
                            language_mobile += $(this).html();
                            $(this).detach();
                        });
                        language_mobile += '</li>';
                        $(this.main_menu).append(language_mobile);
                    }

                    //wpml-ls-slot-3 wpml-ls-item wpml-ls-item-en wpml-ls-menu-item wpml-ls-first-item menu-item menu-eng
                }
            },

            columnSticky(){
                $(".ap-column-sticky").children('.col-inner').addClass('ap-column-inner-sticky');
                var step_tablet = this.md_brk;
                $(window).on('scroll', function(){
                    if($(window).width() > step_tablet){
                        var offsetTop = $('#header-nav').outerHeight() + 40;
                        if($('#site-masthead').hasClass('sticky')){
                            $('.ap-column-inner-sticky').addClass('header-is-sticky');
                        } else{
                            $('.ap-column-inner-sticky').removeClass('header-is-sticky');
                        }
                        $(".ap-column-inner-sticky").stick_in_parent({
                                parent : '.ap-column-sticky',
                                offset_top: offsetTop,
                            }
                        );
                    } else{
                        $(".ap-column-inner-sticky").trigger("sticky_kit:detach");
                    }
                });
            },

            stickyButtonLp(){
                if($(window).width() <= this.xs_brk) {
                    let btn = $('.header-lp .btn-scroll-to-element');
                    if(btn.length > 0){
                        $(window).on('load scroll', function(){
                            let heightView = $(window).innerHeight();
                            let distanceForm = $('#' + btn.attr('data-scrolltoelement')).offset().top - heightView;
                            if (window.pageYOffset > distanceForm) {
                                btn.addClass("d-none");
                            } else {
                                btn.removeClass("d-none");
                            }
                        });
                    }
                }
            },
        };

        AdvivaPress.init();

        let body = jQuery('body');

        jQuery(window).on('load scroll resize', function (e) {
            if (e.type === 'load') {
                body.trigger('advivapress.window.finalize');
            }
            if (e.type === 'scroll') {
                jQuery('body').trigger('advivapress.window.scroll');
            }
            if (e.type === 'resize') {
                jQuery('body').trigger('advivapress.window.resize');
            }
        });
    },
    finalize() {
        jQuery('body').trigger('advivapress.finalize');
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
